import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Menu = () => {
  /* ================= AUTH ================= */
  const user = useSelector((state) => state.auth.user);
  const userId = user?.id; // ✅ SAFE
  const isTemplateAllowed = userId === 2;

  /* ================= ROUTES ================= */
  const { pathname } = useLocation();

  const isSessionRoute = pathname.startsWith('/coach/session');
  const isAttendanceRoute = pathname.startsWith('/coach/attendance');
  const isStudentsRoute = pathname.startsWith('/coach/students');
  const isTemplateRoute = pathname.startsWith('/coach/template');

  const isActive = (path) => pathname === path;

  /* ================= SESSION MENU ================= */
  const [isSessionOpen, setIsSessionOpen] = useState(false);

  useEffect(() => {
    setIsSessionOpen(isSessionRoute);
  }, [isSessionRoute]);

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      {/* ================= BRAND ================= */}
      <Link to="/" className="brand-link">
        <img
          src="/images/pawn.png"
          alt="Logo"
          className="brand-image img-circle elevation-3"
          style={{ opacity: '.8' }}
        />
        <span className="brand-text font-weight-light">
          Aadhav Academy
        </span>
      </Link>

      <div className="sidebar">
        {/* ================= USER PANEL ================= */}
        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
          <div className="image">
            <img
              src="/images/user.png"
              className="img-circle elevation-2"
              alt="User"
            />
          </div>
          <div className="info">
            <span className="d-block text-white">
              {user?.name || 'User'}
            </span>
          </div>
        </div>

        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column">

            {/* ================= STUDENTS ================= */}
            <li className="nav-item">
              <Link
                to="/coach/students"
                className={`nav-link ${isStudentsRoute ? 'active' : ''}`}
              >
                <i className="nav-icon fa fa-users" />
                <p>Students</p>
              </Link>
            </li>

            {/* ================= SESSION MANAGEMENT ================= */}
            <li className={`nav-item ${isSessionOpen ? 'menu-open' : ''}`}>
              <a
                href="#"
                className={`nav-link ${isSessionRoute ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  setIsSessionOpen((prev) => !prev);
                }}
              >
                <i className="nav-icon fas fa-cogs" />
                <p>
                  Session Management
                  <i className="right fas fa-angle-left" />
                </p>
              </a>

              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <Link
                    to="/coach/session-master"
                    className={`nav-link ${
                      isActive('/coach/session-master') ? 'active' : ''
                    }`}
                  >
                    <i className="far fa-circle nav-icon" />
                    <p>Session Master</p>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    to="/coach/session-info"
                    className={`nav-link ${
                      isActive('/coach/session-info') ? 'active' : ''
                    }`}
                  >
                    <i className="far fa-circle nav-icon" />
                    <p>Session Info</p>
                  </Link>
                </li>
              </ul>
            </li>

            {/* ================= ATTENDANCE ================= */}
            <li className="nav-item">
              <Link
                to="/coach/attendance"
                className={`nav-link ${isAttendanceRoute ? 'active' : ''}`}
              >
                <i className="nav-icon fas fa-user-check" />
                <p>Attendance</p>
              </Link>
            </li>

            {/* ================= TEMPLATE (ONLY USER ID 2) ================= */}
            {isTemplateAllowed && (
              <li className="nav-item">
                <Link
                  to="/coach/template"
                  className={`nav-link ${isTemplateRoute ? 'active' : ''}`}
                >
                  <i className="nav-icon fas fa-layer-group" />
                  <p>Template</p>
                </Link>
              </li>
            )}

          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Menu;
